import { Text } from "@mantine/core";

/* beta label that is just formatted superscript text
  put this label within a <Text> component to get the correct font size! */
export const BetaLabel = () => {
  return (
    <Text inherit component="sup" span fz="0.7em" pl={4}>
      beta
    </Text>
  );
};
